module.exports = __webpack_public_path__ + "img/icon_1.fa298981.png";